(function(angular){
	'use strict';
	
	var fieldObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			customErrorMessages: '<',
			input: '<?',
			label: '@?'
		},
		controller: [
			FieldFunction
		],
		controllerAs: 'field',
		transclude: true
	};
	
	angular
		.module('formValidationModule')
		.component('field', fieldObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/form-validation/field.html';
	}
	
	function FieldFunction(){
		var field = this;

		field.removeServerSide = function() {
			if(angular.isDefined(field.input)) {
				field.input.$setValidity('serverside', true);
				field.input.serverSideErrorMsgs = undefined;
			}
		};
	}
})(window.angular);